export default __webpack_public_path__ + "static/media/ground2.ec639264.png";